"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPimVehicleConfigurations = exports.mapCrystallizeVehicleConfiguration = exports.mapCrystallizeVehicleModel = exports.mapCrystallizeVehicleModelSeries = exports.mapCrystallizeVehicleMake = exports.mapCrystallizeDefaultVariant = exports.mapCrystallizeAccessories = exports.mapCrystallizePackages = exports.mapCrystallizeTireSets = exports.mapCrystallizeInteriors = exports.mapCrystallizeVarnishes = exports.mapCrystallizeImages = exports.mapVehicleModel = exports.getMake = exports.mapBodywork = exports.mapInteriors = exports.mapFuel = exports.mapImages = exports.getBooleanContentById = exports.getParagraphCollectionContentById = exports.getRichTextContentById = exports.getPropertiesTableContentById = exports.getImageContentById = exports.getItemRelationsContentById = exports.getSingleLineContentById = void 0;
const core_api_1 = require("../../../../interfaces/crystallize/core-api");
const aggregators_1 = require("./aggregators");
const enums_1 = require("../../../../enums");
const _getComponentById = (data, id) => {
    if (!data || !data.components) {
        return null;
    }
    return data.components.find((component) => component.id === id);
};
/**
 * Parse Crystallize component `SingleLine`.
 */
const getSingleLineContentById = (data, id) => {
    const component = _getComponentById(data, id);
    if (!component || !component.content || component.type !== core_api_1.ComponentType.SingleLine) {
        return null;
    }
    return component.content.text;
};
exports.getSingleLineContentById = getSingleLineContentById;
/**
 * Parse Crystallize component `ItemRelations`.
 */
const getItemRelationsContentById = (data, id) => {
    const component = _getComponentById(data, id);
    if (!component || !component.content || component.type !== core_api_1.ComponentType.ItemRelations) {
        return null;
    }
    return component.content.items;
};
exports.getItemRelationsContentById = getItemRelationsContentById;
/**
 * Parse Crystallize component `Images`.
 */
const getImageContentById = (data, id) => {
    const component = _getComponentById(data, id);
    if (!component || !component.content || component.type !== core_api_1.ComponentType.Images) {
        return null;
    }
    return component.content.images;
};
exports.getImageContentById = getImageContentById;
/**
 * Parse Crystallize component `PropertiesTable`.
 */
const getPropertiesTableContentById = (data, id) => {
    const component = _getComponentById(data, id);
    if (!component || !component.content || component.type !== core_api_1.ComponentType.PropertiesTable) {
        return null;
    }
    return component.content.sections;
};
exports.getPropertiesTableContentById = getPropertiesTableContentById;
// export const getPropertiesTableSectionValues = (
//   data: PropertiesTableSection[],
//   sectionTitle: string,
// ): PropertiesTableValue[] => {
//   if (!data) {
//     return null;
//   }
//
//   const section = data.find((section) => section.title === sectionTitle);
//
//   return section ? section.properties : null;
// };
/**
 * Parse Crystallize component `RichText`.
 */
const getRichTextContentById = (data, id) => {
    const component = _getComponentById(data, id);
    if (!component || !component.content || component.type !== core_api_1.ComponentType.RichText) {
        return null;
    }
    return component.content.plainText;
};
exports.getRichTextContentById = getRichTextContentById;
/**
 * Parse Crystallize component `ParagraphCollection`.
 */
const getParagraphCollectionContentById = (data, id) => {
    const component = _getComponentById(data, id);
    if (!component || !component.content || component.type !== core_api_1.ComponentType.ParagraphCollection) {
        return null;
    }
    return component.content.paragraphs;
};
exports.getParagraphCollectionContentById = getParagraphCollectionContentById;
/**
 * Parse Crystallize component `Switch`.
 */
const getBooleanContentById = (data, id) => {
    const component = _getComponentById(data, id);
    if (!component || !component.content || component.type !== core_api_1.ComponentType.Boolean) {
        return null;
    }
    return component.content.value;
};
exports.getBooleanContentById = getBooleanContentById;
const mapImages = (images) => {
    if (!images) {
        return [];
    }
    return images.map((image) => {
        const imageVariants = Array.isArray(image.variants) ? image.variants : [];
        return {
            url: image.url || null,
            variants: imageVariants.map((variant) => {
                return {
                    url: variant === null || variant === void 0 ? void 0 : variant.url,
                    width: variant === null || variant === void 0 ? void 0 : variant.width,
                };
            }),
        };
    });
};
exports.mapImages = mapImages;
const mapFuel = (data) => {
    const fuelType = data && data.fuelType ? data.fuelType : null;
    return fuelType ? { name: data.name, type: (0, enums_1.getFuelEnumValueByName)(fuelType) } : null;
};
exports.mapFuel = mapFuel;
// export const mapVarnishes = (data: Product): ICrystallizeVarnish[] => {
//   const varnishItems = getItemRelationsContentById(data, VehicleModelSeriesFieldIds.VARNISHES);
//
//   if (!varnishItems || !Array.isArray(varnishItems)) {
//     return [];
//   }
//
//   return varnishItems.map((varnish) => {
//     const id = varnish.id;
//     const name = varnish.name;
//     const varnishCode = getSingleLineContentById(varnish, VarnishFieldIds.VARNISH_CODE);
//     const type = getSingleLineContentById(varnish, VarnishFieldIds.TYPE);
//     const hexCode = getSingleLineContentById(varnish, VarnishFieldIds.HEX_CODE);
//     const cosmetics = aggregateCosmeticProperties(data, CosmeticSectionTitles.VARNISHES, varnishCode);
//
//     return {
//       id,
//       name,
//       varnishCode,
//       type,
//       hexCode,
//       additionalPrice: cosmetics.price,
//       isRecommended: cosmetics.isRecommended,
//     };
//   });
// };
const mapInteriors = (data) => {
    if (!data || !Array.isArray(data.interiors)) {
        return [];
    }
    return data.interiors.map((interior) => {
        const id = interior.id;
        const name = interior.name;
        const images = (0, exports.mapImages)(interior.images);
        const interiorCode = interior.interiorCode;
        const type = interior.type;
        const cosmetics = { price: null, isRecommended: null };
        return {
            id,
            name,
            images,
            interiorCode,
            type,
            additionalPrice: cosmetics.price,
            isRecommended: cosmetics.isRecommended,
        };
    });
};
exports.mapInteriors = mapInteriors;
const mapBodywork = (data) => {
    const bodywork = data && data.bodywork ? data.bodywork : null;
    return bodywork ? { name: data.name, type: (0, enums_1.getBodyworkEnumValueByName)(bodywork) } : null;
};
exports.mapBodywork = mapBodywork;
// export const mapPrice = (data: Product): number => {
//   const variant = data ? data['defaultVariant'] : null;
//
//   if (!variant || !variant.price) {
//     return null;
//   }
//
//   return variant.price;
// };
// export const mapSku = (data: Product): string => {
//   const variant = data ? data['defaultVariant'] : null;
//
//   if (!variant || !variant.sku) {
//     return null;
//   }
//
//   return variant.sku;
// };
const getMake = (make) => {
    const makeName = make && make.name ? make.name : null;
    return (0, enums_1.getMakeCodeByName)(makeName);
};
exports.getMake = getMake;
// export const aggregateCosmeticProperties = (
//   data: Product,
//   sectionTitle: CosmeticSectionTitles,
//   key: string,
// ): { price: number; isRecommended: boolean } => {
//   const getPrice = (): number => {
//     const pricing = getPropertiesTableSectionValues(
//       getPropertiesTableContentById(data, VehicleConfigurationFieldIds.COSMETIC_PRICING),
//       sectionTitle,
//     );
//     const priceEntry = pricing ? pricing.find((price) => price.key === key) : null;
//
//     return priceEntry ? parseInt(priceEntry.value) : null;
//   };
//
//   const getIsRecommended = (): boolean => {
//     const recommendations = getPropertiesTableSectionValues(
//       getPropertiesTableContentById(data, VehicleConfigurationFieldIds.COSMETIC_RECOMMENDATIONS),
//       sectionTitle,
//     );
//
//     return recommendations ? Boolean(recommendations.find((recommendation) => recommendation.key === key)) : false;
//   };
//
//   return {
//     price: getPrice(),
//     isRecommended: getIsRecommended(),
//   };
// };
// export const mapTires = (data: ICrystallizeVehicleModel): ITireSet[] => {
//   const tireItems = data && data.tires ? data.tires : null;
//
//   if (!tireItems || !Array.isArray(tireItems)) {
//     return [];
//   }
//
//   return tireItems.map((tire) => {
//     const id = tire.id;
//     const name = tire.name;
//     const images = mapImages(tire.images);
//     const rimManufacturer = tire.rimManufacturer;
//     const tireManufacturer = tire.tireManufacturer;
//     const nobos = tire.nowaCode;
//     const type = null;
//     const description = tire.description;
//     const cosmetics = { price: null, isRecommended: null };
//
//     return {
//       id,
//       name,
//       images,
//       rimManufacturer,
//       tireManufacturer,
//       nobos,
//       type,
//       description,
//       additionalPrice: cosmetics.price,
//       isRecommended: cosmetics.isRecommended,
//     };
//   });
// };
// export const mapSalesPackages = (vehicle: ICrystallizeVehicleConfiguration): IPackage[] => {
//   if (!vehicle.salesPackages) {
//     return null;
//   }
//
//   return vehicle.salesPackages.map((_package) => {
//     const crystallizePackage = aggregateSalesPackages(_package);
//
//     const additionalPrice = _package.additionalPrice;
//     const equipment = _package.equipment;
//
//     return {
//       id: _package.id,
//       name: _package.name,
//       additionalPrice: additionalPrice ? parseInt(additionalPrice) : null,
//       equipment,
//     };
//   });
// };
// export const mapAccessories = (data: ICrystallizeVehicleModelSeries): IAccessory[] => {
//   const accessories = data && data.accessories ? data.accessories : null;
//
//   if (!accessories || !Array.isArray(accessories)) {
//     return [];
//   }
//
//   return accessories.map((accessory) => {
//     const id = accessory.id;
//     const name = accessory.name;
//     const price = null;
//     const sku = accessory.articleNumber;
//     const images = mapImages(accessory.images);
//     const manufacturer = null;
//     const customerPrice = null;
//     const retailPrice = accessory.retailPrice;
//     const margin = accessory.retailerMargin;
//
//     return {
//       id,
//       name,
//       price,
//       sku,
//       images,
//       manufacturer,
//       customerPrice,
//       retailPrice,
//       margin,
//     };
//   });
// };
// export const mapEquipment = (data: ICrystallizeVehicleModel): IEquipmentBundle[] => {
//   const equipment = data.equipment;
//
//   if (!equipment || !Array.isArray(equipment)) {
//     return [];
//   }
//
//   return [
//     {
//       name: 'Standardutstyr',
//       equipment,
//     },
//   ];
// };
// export const getModelData = (vehicle: Product) => {
//   const models = getItemRelationsContentById(vehicle, VehicleConfigurationFieldIds.MODEL);
//   return models ? models[0] : null; // TODO: Check if it is always a single item in the array.
// };
const mapVehicleModel = (vehicle) => {
    var _a, _b;
    const model = vehicle && vehicle.model ? vehicle.model : null;
    const _series = model && model.modelSeries ? model.modelSeries : null;
    const _make = _series && _series.make ? _series.make : null;
    if (!model) {
        return null;
    }
    const id = model.id;
    const name = model.name;
    const make = (0, exports.getMake)(_make);
    const images = (0, exports.mapImages)(model.images);
    const vehicleType = model.vehicleType;
    const series = _series && _series.name ? _series.name : null;
    const salesArticle = model.salesArticle;
    const fuel = (0, exports.mapFuel)(model);
    const powerTrain = model.powertrain;
    const effect = (_a = vehicle.extraEffect) !== null && _a !== void 0 ? _a : model.effect;
    const electricProps = () => {
        var _a, _b, _c, _d;
        const batteryCapacity = (_a = vehicle.extraBatteryCapacity) !== null && _a !== void 0 ? _a : model.batteryCapacity;
        const chargingCapacityAC = (_b = vehicle.extraChargingCapacityAc) !== null && _b !== void 0 ? _b : model.chargingCapacityAc;
        const chargingCapacityDC = (_c = vehicle.extraChargingCapacityDc) !== null && _c !== void 0 ? _c : model.chargingCapacityDc;
        const electricRange = (_d = vehicle.extraElectricRange) !== null && _d !== void 0 ? _d : model.electricRange;
        return {
            batteryCapacity,
            chargingCapacityAC,
            chargingCapacityDC,
            electricRange,
        };
    };
    const towingCapacity = (_b = vehicle.extraTowingCapacity) !== null && _b !== void 0 ? _b : model.towingCapacity;
    const equipment = (0, aggregators_1.aggregateStandardEquipment)(model.equipment);
    const pricing = () => {
        const importerSupport = vehicle.importerSupport;
        const deliveryCharge = vehicle.deliveryCharge;
        const oneTimeFee = null;
        const wreckage = vehicle.wreckage;
        const source = null;
        const importerSupportExcludingVat = vehicle.importerSupportExcludingVat;
        const deliveryChargeExcludingVat = vehicle.deliveryChargeExcludingVat;
        const wreckageExcludingVat = vehicle.wreckageExcludingVat;
        return {
            importerSupport,
            deliveryCharge,
            oneTimeFee,
            wreckage,
            source,
            importerSupportExcludingVat,
            deliveryChargeExcludingVat,
            wreckageExcludingVat,
        };
    };
    const bodywork = (0, exports.mapBodywork)(model);
    const consumption = model.consumption;
    const luggageVolume = model.luggageVolume;
    const seatCount = model.seatCount;
    const transmission = model.transmission;
    const year = model.year;
    return {
        id,
        name,
        make,
        images: images.length > 0 ? images : (0, aggregators_1.buildVariantImagesFromSizes)(aggregators_1.DefaultImageUrl.VEHICLE),
        vehicleType,
        series,
        salesArticle,
        fuel,
        powerTrain,
        effect,
        electricProps: electricProps(),
        towingCapacity,
        equipment,
        pricing: pricing(),
        bodywork,
        consumption,
        luggageVolume,
        seatCount,
        transmission,
        year,
    };
};
exports.mapVehicleModel = mapVehicleModel;
const mapCrystallizeImages = (images) => {
    if (!images) {
        return [];
    }
    return images.map((image) => {
        const imageVariants = Array.isArray(image.variants) ? image.variants : [];
        return {
            altText: image.altText || null,
            caption: image.caption ? image.caption.plainText.join(' ') : null,
            url: image.url || null,
            variants: imageVariants.map((variant) => {
                return {
                    height: variant.height || null,
                    url: variant.url || null,
                    width: variant.width || null,
                };
            }),
        };
    });
};
exports.mapCrystallizeImages = mapCrystallizeImages;
const mapCrystallizeVarnishes = (data) => {
    const varnishItems = (0, exports.getItemRelationsContentById)(data, enums_1.VehicleModelSeriesFieldIds.VARNISHES);
    if (!varnishItems || !Array.isArray(varnishItems)) {
        return [];
    }
    return varnishItems.map((varnish) => {
        if (!varnish) {
            return null;
        }
        const compatibility = (0, exports.getPropertiesTableContentById)(varnish, enums_1.VarnishFieldIds.COMPATIBILITY);
        const hexCode = (0, exports.getSingleLineContentById)(varnish, enums_1.VarnishFieldIds.HEX_CODE);
        const id = varnish.id;
        const name = varnish.name;
        const type = (0, exports.getSingleLineContentById)(varnish, enums_1.VarnishFieldIds.TYPE);
        const varnishCode = (0, exports.getSingleLineContentById)(varnish, enums_1.VarnishFieldIds.VARNISH_CODE);
        return {
            compatibility: Array.isArray(compatibility) && compatibility.length > 0 ? compatibility[0] : null,
            hexCode,
            id,
            name,
            type,
            varnishCode,
        };
    });
};
exports.mapCrystallizeVarnishes = mapCrystallizeVarnishes;
const mapCrystallizeInteriors = (data) => {
    const interiorItems = (0, exports.getItemRelationsContentById)(data, enums_1.VehicleModelFieldIds.INTERIORS);
    if (!interiorItems || !Array.isArray(interiorItems)) {
        return [];
    }
    return interiorItems.map((interior) => {
        const id = interior.id;
        const images = (0, exports.getImageContentById)(interior, enums_1.InteriorFieldIds.IMAGES);
        const interiorCode = (0, exports.getSingleLineContentById)(interior, enums_1.InteriorFieldIds.INTERIOR_CODE);
        const name = interior.name;
        const type = (0, exports.getSingleLineContentById)(interior, enums_1.InteriorFieldIds.TYPE);
        return {
            id,
            images,
            interiorCode,
            name,
            type,
        };
    });
};
exports.mapCrystallizeInteriors = mapCrystallizeInteriors;
const mapCrystallizeTireSets = (data) => {
    const tireItems = (0, exports.getItemRelationsContentById)(data, enums_1.VehicleModelFieldIds.TIRES);
    if (!tireItems || !Array.isArray(tireItems)) {
        return [];
    }
    return tireItems.map((tire) => {
        if (!tire) {
            return null;
        }
        const description = (0, exports.getRichTextContentById)(tire, enums_1.TireSetFieldIds.DESCRIPTION);
        const id = tire.id;
        const images = (0, exports.getImageContentById)(tire, enums_1.TireSetFieldIds.IMAGES);
        const name = tire.name;
        const nowaCode = (0, exports.getSingleLineContentById)(tire, enums_1.TireSetFieldIds.NOWA_CODE);
        const rimManufacturer = (0, exports.getSingleLineContentById)(tire, enums_1.TireSetFieldIds.RIM_MANUFACTURER);
        const spikes = (0, exports.getBooleanContentById)(tire, enums_1.TireSetFieldIds.SPIKES);
        const tireManufacturer = (0, exports.getSingleLineContentById)(tire, enums_1.TireSetFieldIds.TIRE_MANUFACTURER);
        const winterWheel = (0, exports.getBooleanContentById)(tire, enums_1.TireSetFieldIds.WINTER_WHEEL);
        return {
            description: description && description.length > 0 ? description.join(' ') : null,
            id,
            images,
            name,
            nowaCode,
            rimManufacturer,
            spikes,
            tireManufacturer,
            winterWheel,
        };
    });
};
exports.mapCrystallizeTireSets = mapCrystallizeTireSets;
const mapCrystallizePackages = (data) => {
    if (!data) {
        return [];
    }
    return data.map((packageItem) => {
        if (!packageItem) {
            return null;
        }
        const additionalPrice = (0, exports.getSingleLineContentById)(packageItem, enums_1.PackageFieldIds.ADDITIONAL_PRICE);
        const equipment = (0, exports.getParagraphCollectionContentById)(packageItem, enums_1.PackageFieldIds.EQUIPMENT);
        const id = packageItem.id;
        const name = packageItem.name;
        return {
            additionalPrice: additionalPrice ? parseFloat(additionalPrice) : null,
            equipment,
            id,
            name,
        };
    });
};
exports.mapCrystallizePackages = mapCrystallizePackages;
const mapCrystallizeAccessories = (data) => {
    const accessoryItems = (0, exports.getItemRelationsContentById)(data, enums_1.VehicleModelSeriesFieldIds.ACCESSORIES);
    if (!accessoryItems || !Array.isArray(accessoryItems)) {
        return [];
    }
    return accessoryItems.map((accessory) => {
        if (!accessory) {
            return null;
        }
        const articleName = (0, exports.getSingleLineContentById)(accessory, enums_1.AccessoryFieldIds.ARTICLE_NAME);
        const articleNumber = (0, exports.getSingleLineContentById)(accessory, enums_1.AccessoryFieldIds.ARTICLE_NUMBER);
        const assemblyHours = (0, exports.getSingleLineContentById)(accessory, enums_1.AccessoryFieldIds.ASSEMBLY_HOURS);
        const assemblyPrice = (0, exports.getSingleLineContentById)(accessory, enums_1.AccessoryFieldIds.ASSEMBLY_PRICE);
        const assemblyPriceExcludingVat = (0, exports.getSingleLineContentById)(accessory, enums_1.AccessoryFieldIds.ASSEMBLY_PRICE_EXCLUDING_VAT);
        const description = (0, exports.getSingleLineContentById)(accessory, enums_1.AccessoryFieldIds.DESCRIPTION);
        const id = accessory.id;
        const images = (0, exports.getImageContentById)(accessory, enums_1.AccessoryFieldIds.IMAGES);
        const modelCompatibility = (0, exports.getPropertiesTableContentById)(accessory, enums_1.AccessoryFieldIds.MODEL_COMPATIBILITY);
        const name = accessory.name;
        const retailPrice = (0, exports.getSingleLineContentById)(accessory, enums_1.AccessoryFieldIds.RETAIL_PRICE);
        const retailPriceExcludingVat = (0, exports.getSingleLineContentById)(accessory, enums_1.AccessoryFieldIds.RETAIL_PRICE_EXCLUDING_VAT);
        const retailerMargin = (0, exports.getSingleLineContentById)(accessory, enums_1.AccessoryFieldIds.RETAILER_MARGIN);
        const retailerMarginExcludingVat = (0, exports.getSingleLineContentById)(accessory, enums_1.AccessoryFieldIds.RETAILER_MARGIN_EXCLUDING_VAT);
        return {
            articleName,
            articleNumber,
            assemblyHours: assemblyHours ? parseFloat(assemblyHours) : null,
            assemblyPrice: assemblyPrice ? parseFloat(assemblyPrice) : null,
            assemblyPriceExcludingVat: assemblyPriceExcludingVat ? parseFloat(assemblyPriceExcludingVat) : null,
            description,
            id,
            images,
            modelCompatibility: modelCompatibility[0],
            name,
            retailPrice: retailPrice ? parseFloat(retailPrice) : null,
            retailPriceExcludingVat: retailPriceExcludingVat ? parseFloat(retailPriceExcludingVat) : null,
            retailerMargin: retailerMargin ? parseFloat(retailerMargin) : null,
            retailerMarginExcludingVat: retailerMarginExcludingVat ? parseFloat(retailerMarginExcludingVat) : null,
        };
    });
};
exports.mapCrystallizeAccessories = mapCrystallizeAccessories;
// export const mapCosmeticTable = (data: PropertiesTableSection[]): IPropertiesTableSection[] => {
//   return data
//     ? data.map((section) => {
//       return {
//         title: section.title || null,
//         content: section.properties
//           ? section.properties.map((entry) => {
//             return {
//               key: entry.key || null,
//               value: entry.value || null
//             };
//           })
//           : []
//       };
//     })
//     : [];
// };
const mapCrystallizeDefaultVariant = (data) => {
    if (!data) {
        return null;
    }
    const defaultVariant = data['defaultVariant'];
    const images = defaultVariant ? defaultVariant.images || [] : [];
    const price = defaultVariant ? defaultVariant.price : null;
    const sku = defaultVariant ? defaultVariant.sku || null : null;
    return {
        images,
        price,
        sku,
    };
};
exports.mapCrystallizeDefaultVariant = mapCrystallizeDefaultVariant;
const mapCrystallizeVehicleMake = (data) => {
    if (!data) {
        return null;
    }
    const description = (0, exports.getRichTextContentById)(data, enums_1.VehicleMakeFieldIds.DESCRIPTION);
    const id = data.id;
    const logo = (0, exports.getImageContentById)(data, enums_1.VehicleMakeFieldIds.LOGO);
    const name = data.name;
    const url = (0, exports.getSingleLineContentById)(data, enums_1.VehicleMakeFieldIds.URL);
    return {
        description: description.length > 0 ? description.join(' ') : null,
        id,
        logo,
        name,
        url,
    };
};
exports.mapCrystallizeVehicleMake = mapCrystallizeVehicleMake;
const mapCrystallizeVehicleModelSeries = (data) => {
    if (!data) {
        return null;
    }
    const cosmeticPricingContent = (0, exports.getPropertiesTableContentById)(data, enums_1.VehicleModelSeriesFieldIds.COSMETIC_PRICING);
    const cosmeticRecommendationsContent = (0, exports.getPropertiesTableContentById)(data, enums_1.VehicleModelSeriesFieldIds.COSMETIC_RECOMMENDATIONS);
    const id = data.id;
    const vehicleMakeItems = (0, exports.getItemRelationsContentById)(data, enums_1.VehicleModelSeriesFieldIds.MAKE);
    const name = data.name;
    const make = vehicleMakeItems && Array.isArray(vehicleMakeItems) ? (0, exports.mapCrystallizeVehicleMake)(vehicleMakeItems[0]) : null;
    return {
        accessories: (0, exports.mapCrystallizeAccessories)(data),
        cosmeticPricing: cosmeticPricingContent,
        cosmeticRecommendations: cosmeticRecommendationsContent,
        id,
        make,
        name,
        varnishes: (0, exports.mapCrystallizeVarnishes)(data),
    };
};
exports.mapCrystallizeVehicleModelSeries = mapCrystallizeVehicleModelSeries;
const mapCrystallizeVehicleModel = (data) => {
    if (!data) {
        return null;
    }
    const batteryCapacity = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.BATTERY_CAPACITY);
    const bodywork = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.BODYWORK);
    const chargingCapacityAc = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.CHARGING_CAPACITY_AC);
    const chargingCapacityDc = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.CHARGING_CAPACITY_DC);
    const consumption = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.CONSUMPTION);
    const cosmeticPricingContent = (0, exports.getPropertiesTableContentById)(data, enums_1.VehicleModelFieldIds.COSMETIC_PRICING);
    const cosmeticRecommendationsContent = (0, exports.getPropertiesTableContentById)(data, enums_1.VehicleModelFieldIds.COSMETIC_RECOMMENDATIONS);
    const effect = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.EFFECT);
    const electricRange = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.ELECTRIC_RANGE);
    const equipment = (0, exports.getRichTextContentById)(data, enums_1.VehicleModelFieldIds.EQUIPMENT);
    const fuelType = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.FUEL_TYPE);
    const id = data.id;
    const images = (0, exports.getImageContentById)(data, enums_1.VehicleModelFieldIds.IMAGES);
    const interiors = (0, exports.mapCrystallizeInteriors)(data);
    const luggageVolume = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.LUGGAGE_VOLUME);
    const name = data.name;
    const powertrain = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.POWERTRAIN);
    const salesArticle = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.SALES_ARTICLE);
    const seatCount = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.SEAT_COUNT);
    const tires = (0, exports.mapCrystallizeTireSets)(data);
    const towingCapacity = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.TOWING_CAPACITY);
    const transmission = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.TRANSMISSION);
    const vehicleModelSeriesItems = (0, exports.getItemRelationsContentById)(data, enums_1.VehicleModelFieldIds.MODEL_SERIES);
    const vehicleType = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.VEHICLE_TYPE);
    const year = (0, exports.getSingleLineContentById)(data, enums_1.VehicleModelFieldIds.YEAR);
    const modelSeries = vehicleModelSeriesItems && Array.isArray(vehicleModelSeriesItems)
        ? (0, exports.mapCrystallizeVehicleModelSeries)(vehicleModelSeriesItems[0])
        : null;
    return {
        batteryCapacity,
        bodywork,
        chargingCapacityAc,
        chargingCapacityDc,
        consumption,
        cosmeticPricing: cosmeticPricingContent,
        cosmeticRecommendations: cosmeticRecommendationsContent,
        effect,
        electricRange,
        equipment,
        fuelType,
        id,
        images,
        interiors,
        luggageVolume: luggageVolume ? parseFloat(luggageVolume) : null,
        modelSeries,
        name,
        powertrain,
        salesArticle,
        seatCount: seatCount ? parseInt(seatCount) : null,
        tires,
        towingCapacity,
        transmission,
        vehicleType,
        year: year ? parseInt(year) : null,
    };
};
exports.mapCrystallizeVehicleModel = mapCrystallizeVehicleModel;
const mapCrystallizeVehicleConfiguration = (data) => {
    if (!data) {
        return null;
    }
    const defaultVariant = (0, exports.mapCrystallizeDefaultVariant)(data);
    const customerAdvantage = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.CUSTOMER_ADVANTAGE);
    const customerAdvantageExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.CUSTOMER_ADVANTAGE_EXCLUDING_VAT);
    const deliveryCharge = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.DELIVERY_CHARGE);
    const deliveryChargeExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.DELIVERY_CHARGE_EXCLUDING_VAT);
    const extraBatteryCapacity = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.EXTRA_BATTERY_CAPACITY);
    const extraChargingCapacityAc = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.EXTRA_CHARGING_CAPACITY_AC);
    const extraChargingCapacityDc = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.EXTRA_CHARGING_CAPACITY_DC);
    const extraEffect = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.EXTRA_EFFECT);
    const extraElectricRange = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.EXTRA_ELECTRIC_RANGE);
    const extraTowingCapacity = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.EXTRA_TOWING_CAPACITY);
    const grossCustomerPrice = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.GROSS_CUSTOMER_PRICE);
    const grossCustomerPriceExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.GROSS_CUSTOMER_PRICE_EXCLUDING_VAT);
    const id = data.id;
    const images = defaultVariant.images;
    const importerSupport = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.IMPORTER_SUPPORT);
    const importerSupportExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.IMPORTER_SUPPORT_EXCLUDING_VAT);
    const indicativePrice = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.INDICATIVE_PRICE);
    const indicativePriceExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.INDICATIVE_PRICE_EXCLUDING_VAT);
    const leasingInterestRate = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.LEASING_INTEREST_RATE);
    const loanInterestRate = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.LOAN_INTEREST_RATE);
    const name = data.name;
    const netCustomerPriceIncludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.NET_CUSTOMER_PRICE_INCLUDINGVAT);
    const optionPackageItems = (0, exports.getItemRelationsContentById)(data, enums_1.VehicleConfigurationFieldIds.OPTION_PACKAGES);
    const price = defaultVariant.price;
    const priceExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.PRICE_EXCLUDING_VAT);
    const residualValue3y30k = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RESIDUAL_VALUE_3Y_30K);
    const residualValue3y30kExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RESIDUAL_VALUE_3Y_30K_EXCLUDING_VAT);
    const residualValue3y45k = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RESIDUAL_VALUE_3Y_45K);
    const residualValue3y45kExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RESIDUAL_VALUE_3Y_45K_EXCLUDING_VAT);
    const residualValue3y60k = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RESIDUAL_VALUE_3Y_60K);
    const residualValue3y60kExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RESIDUAL_VALUE_3Y_60K_EXCLUDING_VAT);
    const residualValue4y40k = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RESIDUAL_VALUE_4Y_40K);
    const residualValue4y40kExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RESIDUAL_VALUE_4Y_40K_EXCLUDING_VAT);
    const residualValue4y60k = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RESIDUAL_VALUE_4Y_60K);
    const residualValue4y60kExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RESIDUAL_VALUE_4Y_60K_EXCLUDING_VAT);
    const retailerBasicMargin = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RETAILER_BASIC_MARGIN);
    const retailerBasicMarginExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RETAILER_BASIC_MARGIN_EXCLUDING_VAT);
    const retailerCampaignMargin = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RETAILER_CAMPAIGN_MARGIN);
    const retailerCampaignMarginExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RETAILER_CAMPAIGN_MARGIN_EXCLUDING_VAT);
    const retailerMarginEquipment = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RETAILER_MARGIN_EQUIPMENT);
    const retailerMarginVehicle = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RETAILER_MARGIN_VEHICLE);
    const retailerSupport = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RETAILER_SUPPORT);
    const retailerSupportExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RETAILER_SUPPORT_EXCLUDING_VAT);
    const rims = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.RIMS);
    const salesPackageItems = (0, exports.getItemRelationsContentById)(data, enums_1.VehicleConfigurationFieldIds.SALES_PACKAGES);
    const sku = defaultVariant.sku;
    const suggestedEquipmentPrice = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.SUGGESTED_EQUIPMENT_PRICE);
    const suggestedEquipmentPriceExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.SUGGESTED_EQUIPMENT_PRICE_EXCLUDING_VAT);
    const suggestedVehiclePrice = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.SUGGESTED_VEHICLE_PRICE);
    const suggestedVehiclePriceExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.SUGGESTED_VEHICLE_PRICE_EXCLUDING_VAT);
    const vehicleModelItems = (0, exports.getItemRelationsContentById)(data, enums_1.VehicleConfigurationFieldIds.MODEL);
    const vehicleRoadTax = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.VEHICLE_ROAD_TAX);
    const vehicleRoadTaxExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.VEHICLE_ROAD_TAX_EXCLUDING_VAT);
    const wreckage = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.WRECKAGE);
    const wreckageExcludingVat = (0, exports.getSingleLineContentById)(data, enums_1.VehicleConfigurationFieldIds.WRECKAGE_EXCLUDING_VAT);
    const model = vehicleModelItems && Array.isArray(vehicleModelItems) ? (0, exports.mapCrystallizeVehicleModel)(vehicleModelItems[0]) : null;
    return {
        customerAdvantage: customerAdvantage ? parseFloat(customerAdvantage) : null,
        customerAdvantageExcludingVat: customerAdvantageExcludingVat ? parseFloat(customerAdvantageExcludingVat) : null,
        deliveryCharge: deliveryCharge ? parseFloat(deliveryCharge) : null,
        deliveryChargeExcludingVat: deliveryChargeExcludingVat ? parseFloat(deliveryChargeExcludingVat) : null,
        extraBatteryCapacity,
        extraChargingCapacityAc,
        extraChargingCapacityDc,
        extraEffect,
        extraElectricRange,
        extraTowingCapacity,
        grossCustomerPrice: grossCustomerPrice ? parseFloat(grossCustomerPrice) : null,
        grossCustomerPriceExcludingVat: grossCustomerPriceExcludingVat ? parseFloat(grossCustomerPriceExcludingVat) : null,
        id,
        images,
        importerSupport: importerSupport ? parseFloat(importerSupport) : null,
        importerSupportExcludingVat: importerSupportExcludingVat ? parseFloat(importerSupportExcludingVat) : null,
        indicativePrice: indicativePrice ? parseFloat(indicativePrice) : null,
        indicativePriceExcludingVat: indicativePriceExcludingVat ? parseFloat(indicativePriceExcludingVat) : null,
        leasingBasisPrice: null,
        leasingInterestRate,
        loanInterestRate,
        model,
        name,
        netCustomerPriceIncludingVat: netCustomerPriceIncludingVat ? parseFloat(netCustomerPriceIncludingVat) : null,
        optionPackages: (0, exports.mapCrystallizePackages)(optionPackageItems),
        price,
        priceExcludingVat: priceExcludingVat ? parseFloat(priceExcludingVat) : null,
        residualValue3y30k: residualValue3y30k ? parseFloat(residualValue3y30k) : null,
        residualValue3y30kExcludingVat: residualValue3y30kExcludingVat ? parseFloat(residualValue3y30kExcludingVat) : null,
        residualValue3y45k: residualValue3y45k ? parseFloat(residualValue3y45k) : null,
        residualValue3y45kExcludingVat: residualValue3y45kExcludingVat ? parseFloat(residualValue3y45kExcludingVat) : null,
        residualValue3y60k: residualValue3y60k ? parseFloat(residualValue3y60k) : null,
        residualValue3y60kExcludingVat: residualValue3y60kExcludingVat ? parseFloat(residualValue3y60kExcludingVat) : null,
        residualValue4y40k: residualValue4y40k ? parseFloat(residualValue4y40k) : null,
        residualValue4y40kExcludingVat: residualValue4y40kExcludingVat ? parseFloat(residualValue4y40kExcludingVat) : null,
        residualValue4y60k: residualValue4y60k ? parseFloat(residualValue4y60k) : null,
        residualValue4y60kExcludingVat: residualValue4y60kExcludingVat ? parseFloat(residualValue4y60kExcludingVat) : null,
        retailerBasicMargin: retailerBasicMargin ? parseFloat(retailerBasicMargin) : null,
        retailerBasicMarginExcludingVat: retailerBasicMarginExcludingVat
            ? parseFloat(retailerBasicMarginExcludingVat)
            : null,
        retailerCampaignMargin: retailerCampaignMargin ? parseFloat(retailerCampaignMargin) : null,
        retailerCampaignMarginExcludingVat: retailerCampaignMarginExcludingVat
            ? parseFloat(retailerCampaignMarginExcludingVat)
            : null,
        retailerMarginEquipment,
        retailerMarginVehicle,
        retailerSupport: retailerSupport ? parseFloat(retailerSupport) : null,
        retailerSupportExcludingVat: retailerSupportExcludingVat ? parseFloat(retailerSupportExcludingVat) : null,
        rims,
        salesPackages: (0, exports.mapCrystallizePackages)(salesPackageItems),
        sku,
        suggestedEquipmentPrice: suggestedEquipmentPrice ? parseFloat(suggestedEquipmentPrice) : null,
        suggestedEquipmentPriceExcludingVat: suggestedEquipmentPriceExcludingVat
            ? parseFloat(suggestedEquipmentPriceExcludingVat)
            : null,
        suggestedVehiclePrice: suggestedVehiclePrice ? parseFloat(suggestedVehiclePrice) : null,
        suggestedVehiclePriceExcludingVat: suggestedVehiclePriceExcludingVat
            ? parseFloat(suggestedVehiclePriceExcludingVat)
            : null,
        vehicleRoadTax: vehicleRoadTax ? parseFloat(vehicleRoadTax) : null,
        vehicleRoadTaxExcludingVat: vehicleRoadTaxExcludingVat ? parseFloat(vehicleRoadTaxExcludingVat) : null,
        wreckage: wreckage ? parseFloat(wreckage) : null,
        wreckageExcludingVat: wreckageExcludingVat ? parseFloat(wreckageExcludingVat) : null,
    };
};
exports.mapCrystallizeVehicleConfiguration = mapCrystallizeVehicleConfiguration;
/**
 * This is used by the Next application. Do not change return format.
 */
const mapPimVehicleConfigurations = (data) => {
    if (!data || !data.catalogue || !data.catalogue.children) {
        return [];
    }
    return data.catalogue.children.map((product) => {
        if (!product) {
            return null;
        }
        const vehicle = (0, exports.mapCrystallizeVehicleConfiguration)(product);
        const _model = vehicle.model ? vehicle.model : null;
        const series = _model.modelSeries ? _model.modelSeries : null;
        const id = vehicle.id;
        const name = vehicle.name;
        const price = vehicle.price;
        const priceExcludingVat = vehicle.priceExcludingVat;
        const sku = vehicle.sku;
        const images = (0, exports.mapImages)(vehicle.images);
        const model = (0, exports.mapVehicleModel)(vehicle);
        const salesPackages = (0, aggregators_1.aggregateSalesPackages)(vehicle);
        const optionPackages = [];
        const tires = _model ? (0, aggregators_1.aggregateTireSets)(_model) : null;
        const varnishes = series ? (0, aggregators_1.aggregateVarnishes)(vehicle) : null;
        const interiors = null;
        const rims = vehicle.rims;
        const accessories = (0, aggregators_1.aggregateAccessories)(_model);
        const pricing = () => {
            const customerAdvantage = vehicle.customerAdvantage;
            const customerPrice = null;
            const extraDeliveryCharge = vehicle.deliveryCharge;
            const extraImporterSupport = vehicle.importerSupport;
            const extraOneTimeFee = vehicle.vehicleRoadTax;
            const extraWreckage = vehicle.wreckage;
            const importerSupportExcludingVat = vehicle.importerSupportExcludingVat;
            const indicativePrice = vehicle.indicativePrice;
            const margin = null;
            const netCustomerPrice = null;
            const netCustomerPriceIncludingVat = vehicle.netCustomerPriceIncludingVat;
            const remainder3630 = null;
            const remainder3645 = null;
            const retailerMargin = null;
            const retailerSupport = vehicle.retailerSupport;
            const suggestedVehiclePrice = vehicle.suggestedVehiclePrice;
            const suggestedVehiclePriceExcludingVat = vehicle.suggestedVehiclePriceExcludingVat;
            const suggestedEquipmentPrice = vehicle.suggestedEquipmentPrice;
            const suggestedEquipmentPriceExcludingVat = vehicle.suggestedEquipmentPriceExcludingVat;
            const grossCustomerPrice = vehicle.grossCustomerPrice;
            const grossCustomerPriceExcludingVat = vehicle.grossCustomerPriceExcludingVat;
            const indicativePriceExcludingVat = vehicle.indicativePriceExcludingVat;
            const retailerSupportExcludingVat = vehicle.retailerSupportExcludingVat;
            const customerAdvantageExcludingVat = vehicle.customerAdvantageExcludingVat;
            const vehicleRoadTax = vehicle.vehicleRoadTax;
            const vehicleRoadTaxExcludingVat = vehicle.vehicleRoadTaxExcludingVat;
            const retailerMarginVehicle = vehicle.retailerMarginVehicle;
            const retailerMarginEquipment = vehicle.retailerMarginEquipment;
            const retailerBasicMargin = vehicle.retailerBasicMargin;
            const retailerBasicMarginExcludingVat = vehicle.retailerBasicMarginExcludingVat;
            const retailerCampaignMargin = vehicle.retailerCampaignMargin;
            const retailerCampaignMarginExcludingVat = vehicle.retailerCampaignMarginExcludingVat;
            const residualValue3y30k = vehicle.residualValue3y30k;
            const residualValue3y30kExcludingVat = vehicle.residualValue3y30kExcludingVat;
            const residualValue3y45k = vehicle.residualValue3y45k;
            const residualValue3y45kExcludingVat = vehicle.residualValue3y45kExcludingVat;
            const residualValue3y60k = vehicle.residualValue3y60k;
            const residualValue3y60kExcludingVat = vehicle.residualValue3y60kExcludingVat;
            const residualValue4y40k = vehicle.residualValue4y40k;
            const residualValue4y40kExcludingVat = vehicle.residualValue4y40kExcludingVat;
            const residualValue4y60k = vehicle.residualValue4y60k;
            const residualValue4y60kExcludingVat = vehicle.residualValue4y60kExcludingVat;
            const leasingBasisPrice = vehicle.leasingBasisPrice;
            const leasingInterestRate = vehicle.leasingInterestRate;
            const loanInterestRate = vehicle.loanInterestRate;
            return {
                customerAdvantage,
                customerPrice,
                extraDeliveryCharge,
                extraImporterSupport,
                extraOneTimeFee,
                extraWreckage,
                importerSupportExcludingVat,
                indicativePrice,
                margin,
                netCustomerPrice,
                netCustomerPriceIncludingVat,
                remainder3630,
                remainder3645,
                retailerMargin,
                retailerSupport,
                suggestedVehiclePrice,
                suggestedVehiclePriceExcludingVat,
                suggestedEquipmentPrice,
                suggestedEquipmentPriceExcludingVat,
                grossCustomerPrice,
                grossCustomerPriceExcludingVat,
                indicativePriceExcludingVat,
                retailerSupportExcludingVat,
                customerAdvantageExcludingVat,
                vehicleRoadTax,
                vehicleRoadTaxExcludingVat,
                retailerMarginVehicle,
                retailerMarginEquipment,
                retailerBasicMargin,
                retailerBasicMarginExcludingVat,
                retailerCampaignMargin,
                retailerCampaignMarginExcludingVat,
                residualValue3y30k,
                residualValue3y30kExcludingVat,
                residualValue3y45k,
                residualValue3y45kExcludingVat,
                residualValue3y60k,
                residualValue3y60kExcludingVat,
                residualValue4y40k,
                residualValue4y40kExcludingVat,
                residualValue4y60k,
                residualValue4y60kExcludingVat,
                leasingBasisPrice,
                leasingInterestRate,
                loanInterestRate,
            };
        };
        // Deprecated
        const electricProps = () => {
            const extraEffect = vehicle.extraEffect;
            const extraElectricRange = vehicle.extraElectricRange;
            const extraBatteryCapacity = vehicle.extraBatteryCapacity;
            return {
                extraEffect,
                extraElectricRange,
                extraBatteryCapacity,
            };
        };
        return {
            id,
            name,
            price,
            sku,
            images,
            model,
            salesPackages,
            optionPackages,
            tires,
            varnishes,
            interiors,
            rims,
            accessories,
            pricing: pricing(),
            electricProps: electricProps(),
            priceExcludingVat,
        };
    });
};
exports.mapPimVehicleConfigurations = mapPimVehicleConfigurations;
//# sourceMappingURL=crystallize-pim.js.map